import { Typography } from "@material-ui/core";
import React from "react";

export type SectionTitleProps = {
    id?: string,
    name?: string,
    text: string,
    className?: string,
    style?: React.CSSProperties,
}

export function SectionSubTitle(props: SectionTitleProps) {
    return (
        <React.Fragment>
            <Typography
                {...props}
                id={props.id}
                align={"left"}
                variant={"h5"}
                style={{ ...props.style, marginTop: "1rem", marginBottom: "1rem" }}
                color={"textPrimary"}>
                {props.text}
            </Typography>
        </React.Fragment>
    )
}